import type { FaireProductEntity } from "../../entity_types/product";

export const p_aa7az2t6k3: FaireProductEntity = {
  token: "p_aa7az2t6k3",
  type: "product",
  name: "Lover Of Cancelled Plans Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/f0c0b63545c6b71b8ccf7e1736e5d655718494cfe57a0130a190412fdaf93687.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d71d8b10f76cd7748b95119e838c8aef980baa0ab6cd601307281b6db8029c0.jpeg",
    "https://cdn.faire.com/fastly/f3cd2e7e4c0df1b234be429b5d06e53f0f146359c57f7a917a67b976d51648f4.jpeg",
    "https://cdn.faire.com/fastly/b0c94102fa043d5f969c4713192e372893c26f561443ace038b8eefbf58c577e.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of a cozy reading spot with a fun sentiment that reads \"Lover Of Cancelled Plans\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Lover Of Cancelled Plans metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:40.577Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
